import { cn } from "../../app/components/primitives/utils";
import { AttentionDot } from "./attention";

// The small tab bar inside an item's detail (Ben, 5 Oct), whatever the item's panes are called: [Details & quantity]
// [Artwork] on the order page (ItemSubTabs.tsx) and on a Tharstern-era order's (delivery is the order's own tab).
// A pane holding something the customer must do carries the attention dot.

export interface SubTab<Id extends string> {
  id: Id;
  label: string;
  needsYou: boolean;
}

export function SubTabs<Id extends string>({
  tabs,
  current,
  onSelect,
  isWrapping = false,
}: {
  /** More tabs than fit on a phone: let the bar wrap. */
  isWrapping?: boolean;
  tabs: Array<SubTab<Id>>;
  current: Id;
  onSelect: (id: Id) => void;
}) {
  return (
    <div
      role="tablist"
      aria-label="Item"
      className={cn("flex gap-1", isWrapping && "flex-wrap")}
    >
      {tabs.map((t) => (
        <button
          key={t.id}
          type="button"
          role="tab"
          aria-selected={current === t.id}
          onClick={() => onSelect(t.id)}
          className={cn(
            "flex items-center gap-1.5 rounded-md border px-3 py-1.5 text-sm transition-colors",
            current === t.id
              ? "border-primary/40 bg-primary/5 font-medium text-foreground"
              : "text-muted-foreground hover:text-foreground",
          )}
        >
          {t.label}
          {t.needsYou && <AttentionDot />}
        </button>
      ))}
    </div>
  );
}
